export const fontStyleIdMapping = {
  // heading
  headerXLarge: 'xLarge',
  headerLarge: 'Large',
  headerMedium: 'MediumW1',
  headerSmall: 'Small',
  headerBase: 'Base',

  //label
  labelLargeW1: 'LargeW1',
  labelLargeW2: 'LargeW2',
  labelLargeW3: 'LargeW3',
  labelMediumW1: 'MediumW1',
  labelMediumW2: 'MediumW2',
  labelMediumW3: 'MediumW3',
  labelBaseW1: 'BaseW1',
  labelBaseW2: 'BaseW2',
  labelBaseW3: 'BaseW3',
  labelSmallW1: 'SmallW1',
  labelSmallW2: 'SmallW2',
  labelSmallW3: 'SmallW3',
};
